import { connect } from "react-redux";
import { requestGetAttachmentsByClaimId, requestUploadAttachment } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import Attachments from "./Attachments";

const mapStateToProps = (state: State) => ({
  attachments: state.data.attachments,
});

const mapDispatchToProps = {
  requestGetAttachmentsByClaimId,
  requestUploadAttachment,
};

const AttachmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Attachments);

export default AttachmentsContainer;
